import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import { useMeta } from './hooks/useMeta';

function Eos() {
  useMeta({
    title: 'EOS - Inmaculada Fuentes',
    description: 'EOS: La diosa griega del amanecer, adaptado para lectores con dislexia. Libro infantil ilustrado por Inmaculada Fuentes.',
    image: '/portada_eos.avif',
    url: 'https://inmaculadafuentes.com/eos'
  });

  return (
    <div className="app">
      <Navbar showHomeLink />

      {/* Book Content */}
      <section className="book-page">
        <div className="book-hero">
          <img src="portada_eos_v2.JPG" alt="Portada EOS" className="book-hero-cover" />
          <h1>EOS</h1>
          <p>La diosa griega del amanecer, adaptado para lectores con dislexia.</p>
        </div>

        <div className="book-section">
          <h2>Lo que dicen de EOS</h2>

          <div className="quote">
            <p>"Un cuento delicioso, dulce y entrañable, que logra la sonrisa en los niños al irse a dormir."</p>
            <div className="quote-author">
              <strong>Ana Lena Rivera</strong><br />
              Escritora
            </div>
          </div>

          <div className="quote">
            <p>"Eos viene a dar explicación a lo inexplicable de forma sencilla. Un libro poético y precioso."</p>
            <div className="quote-author">
              <strong>Tabatha Tojaka Doménech</strong><br />
              Profesora de Lengua y Literatura
            </div>
          </div>

          <div className="quote">
            <p>"Un maravilloso relato que camina entre lo mítico y las narraciones antiguas, las que ya no se cuentan por ser secretas, porque desvelaban las realidades ocultas del mundo para producir la magia frente al fuego.</p>
            <p>Aquí, lector, están encerrados los enigmas de las luces crepusculares, del día y la noche, de la Aurora y sus pasiones, sus alegrías y tristezas.</p>
            <p>En este libro, como en todos los buenos, se condensan las voces susurradas que cuentan leyendas, las que una vez habitaron nuestro mundo y ahora yacen dormidas en silencio, esperando que alguien las despierte."</p>
            <div className="quote-author">
              <strong>Fernando J. Múñez</strong><br />
              Filósofo, escritor y guionista
            </div>
          </div>
        </div>

        <div className="book-section">
          <h2>Información del libro</h2>
          <div className="book-info">
            <p><strong>Idea original, texto y edición:</strong> Inmaculada Fuentes Tomás</p>
            <p><strong>Ilustración:</strong> Marc Vaello</p>
            <p><strong>Edita:</strong> Mimadre Universe</p>
            <p><strong>ISBN:</strong> 978-84-09-38348-1</p>
            <p><strong>Tamaño:</strong> 25x25 cm</p>
            <p><strong>Páginas:</strong> 26</p>
            <p><strong>Características:</strong> Ilustrado a todo color, tapa dura</p>
            <p><strong>Impresión:</strong> España - Papel pura celulosa ecológica ECF. Certificados FSC.</p>
            <p><strong>Año:</strong> 2022</p>
            <p><strong>Accesibilidad:</strong> Libro apto para personas con dislexia</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Eos;